var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "list-Dialog",
          attrs: {
            "before-close": _vm.handleClose,
            visible: _vm.visible,
            title: "优惠劵",
            width: "896px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _vm.visible
            ? _c("coupon-list", {
                attrs: {
                  couponData: _vm.coupons,
                  handle: _vm.handle,
                  keyNum: _vm.keyNum,
                  useType: _vm.useType,
                  userIds: _vm.userIds,
                  userType: _vm.userType,
                },
                on: {
                  closeDialog: _vm.closeDialog,
                  getCouponId: _vm.getCouponId,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }